// Dependencies
import React, { createClass, PropTypes } from 'react';
import TypeAheadInput from './typeahead-input';
import DropDownMenu from './typeahead-dropdown';

const TagComponent = createClass({

  propTypes: {
    addOrRemoveTag: PropTypes.func,
    open: PropTypes.bool,
    input: PropTypes.string,
    tags: PropTypes.array,
  },

  getInitialState() {
    return {
      input: '',
    };
  },

  onSelection(value) {
    this.props.addOrRemoveTag(value, 'add');
  },

  searchContent(input) {
    this.setState({ input });
  },

  render() {
    return (
      <div className="tags-typeahead-search-bar-container">
        <div className="multi-select-search-bar">
          <TypeAheadInput addOrRemoveTag={this.props.addOrRemoveTag} searchContent={this.searchContent}/>
        </div>
        {(this.props.open || this.state.input) ? (
          <DropDownMenu
            addOrRemoveTag={this.props.addOrRemoveTag}
            input={this.state.input}
            open={this.props.open || this.state.input}
            tags={this.props.tags}
          />
        ) : undefined}
      </div>
    );
  },
});

export default TagComponent;



// WEBPACK FOOTER //
// ./src/app/components/connections/connections-tags-modal/connections-tags-typeahead/typeahead-input-and-dropdown-container.jsx